import { Component, OnInit } from '@angular/core';
import { CityService } from 'src/app/services/city.service';

@Component({
  selector: 'app-refund-cancellation-policy',
  templateUrl: './refund-cancellation-policy.component.html',
  styleUrls: ['./refund-cancellation-policy.component.scss']
})
export class RefundCancellationPolicyComponent implements OnInit {

  constructor(public cs: CityService) { }

  ngOnInit(): void {
  }

}
